import * as yup from "yup";

export const RoleAssignmentSetupValidationSchema = yup.object({
  userId: yup.string().required("User is required"),
});
